<template>
  <section>
    <LayoutAccount>
      <template #title>
        <h5 v-if="getAppConfigReady && loginSubtitle" v-html="loginSubtitle" class="mb-3 intro-pre-title"></h5>
        {{ $t('pages.signup.headline_title_line1') }} {{ $t('pages.signup.headline_title_line2') }}
      </template>
      <template #subtitle>
        <span>{{$t('pages.signup.headline_txt')}}</span>
        <span><router-link :to="{ name: 'login' }" exact class="p-2 text-primary">{{$t('forms.signup_form.btn_login')}}</router-link></span>
      </template>

      <template #mainContent>
        <SignupForm/>
      </template>
    </LayoutAccount>

    <template v-if="isPicaThirdLevelDomain">
      <B2BSection />
    </template>
  </section>
</template>


<script>
import LayoutAccount from '@/components/LayoutAccount'
import SignupForm from '@/components/SignupForm'
import EventService from '@/services/Event.js'
import {mapGetters} from "vuex";
import B2BSection from "@/components/B2BSection.vue";

export default {
  components: {
    B2BSection,
    LayoutAccount,
    SignupForm
  },

  data() {
    return {
      isEventProvided: false,
      event: null // for custom page only
    }
  },

  computed: {
    ...mapGetters(['isPicaThirdLevelDomain']),
    ...mapGetters('appConfig', ['getAppConfigReady', 'loginSubtitle'])
  },

  created() {
    if (this.$route.params.hasOwnProperty('eventSlug')) {
      const eventSlug = this.$route.params.eventSlug
      this.isEventProvided = !!eventSlug
      EventService.getEventBySlug(eventSlug).then(response => {
        if (response.data.count === 1) {
          this.event = response.data.results[0]
        }
      })
    }
  }
}
</script>
